<template>
    <div class="Pose" :class="{ disable : disable }">  
      <video class="Pose__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="Pose__hand ">{{ msg }}</div>
      <div class="Pose__hand right">{{ res }}</div>  
    </div>
</template>

<script>

import gsap from "gsap"
import '@tensorflow/tfjs-backend-webgl'
import * as mpPose from '@mediapipe/pose'
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm'
tfjsWasm.setWasmPaths(
  `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`)
import * as posedetection from '@tensorflow-models/pose-detection'

export default {

  name: 'Pose',
  render: h => h(), 
  data: ()=>({

    res: '***',
    msg: '***',
    sqt: false

  }),
  beforeDestroy() {
    if(this.rafID)
      cancelAnimationFrame(this.rafID)
    // this.removeHandPose()
  },
  mounted() {
    console.log('Pose');
    this.init()
  },

  methods: {


    setupCamera: async function() {
      
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }

      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          // Only setting the video to a specified size in order to accommodate a
          // point cloud, so on mobile devices accept the default size.
          width: 320,
          height: 240
        },
      })

      video.srcObject = stream

      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    createDetector: async function(model) {
      // return handPoseDetection.createDetector(model, {
      //   runtime: 'mediapipe', // or 'tfjs'
      //   modelType: 'full',
      //   maxHands: 2,
      //   solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/hands@${mpHands.VERSION}`
      // })

      return posedetection.createDetector(model, {
          runtime: 'mediapipe',
          modelType: 'lite',
          solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/pose@${mpPose.VERSION}`
       })




    },

    init: async function() {
      
      let video
      const model = posedetection.SupportedModels.BlazePose

      try {

        video = await this.loadVideo()
        this.$detector = await this.createDetector(model)

        // console.log(this.$detector);

        this.onLoop()

      } catch (e) {
   
        //  console.log('catch '+ e);
        throw e
      }

    },


    checkSquat: async function(pose) { 

      const p1 = pose.keypoints[23]
      const p2 = pose.keypoints[25]
      const r1 = Math.round(Math.abs(p1.y-p2.y))

      if(p1.score > 0.6)
        this.msg = String(r1)

      if(r1 < 20) {
        this.sqt = true
        this.res = 'SQUAT'
      }
      
      if(this.sqt == true && r1 > 45)
        this.sqt = false

      if(this.sqt == false)
        this.res = '***'
      
      return new Promise((resolve) => { 
        resolve() 
      }) 
    },


    

    onLoop: async function() {

      // let hands = await this.$detector.estimateHands( document.querySelector("video"), { flipHorizontal: false })

      // console.log(hands);

      // let res = ''

      // if(hands[0])
      //   res = Math.round(hands[0]['keypoints'][0].x)

      // this.fdl = res


      let poses = await this.$detector.estimatePoses( document.querySelector("video"), { maxPoses: 2, flipHorizontal: false })


      if(poses[0])
        this.checkSquat(poses[0])

      this.rafID = requestAnimationFrame(this.onLoop)   
      
    },

   
    // motionLeft() {
    //   if(this.lft_locked == true)
    //     return
    //   this.lft_locked = true
    //   this.$store.commit('app/MOTION_LEFT')
    //   gsap.delayedCall(.5, ()=>{ this.lft_locked = false })
    // },
    

  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Pose
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px
    font-weight bold

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

   
</style>















